import React, { useEffect, useState } from "react";
import axios from "axios";
import TikTokH from "../../assets/img/budahazr.png";

const API_URL = "https://ffqadir.az/backendtest_9/api/tiktok";
const WHATSAPP_NUMBER = "994991937395";
// "12.50 AZN", "1,200", 15 kimi qiymətlərdən rəqəmi çıxarır
const getNumericPrice = (price) => {
    if (typeof price === "number") return price;

    const cleaned = String(price ?? "")
        .replace(",", ".")
        .replace(/[^\d.]/g, "");

    const num = parseFloat(cleaned);
    return Number.isNaN(num) ? Infinity : num;
};

const TikTok = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let isMounted = true;

        const getProducts = async () => {
            try {
                setLoading(true);
                setError("");

                const response = await axios.get(API_URL);

                const data = Array.isArray(response.data)
                    ? response.data
                    : [];

                const tikTokItems = data
                    .filter(
                        (item) =>
                            item &&
                            typeof item.title === "string" &&
                            item.title.startsWith("TikTok")
                    )
                    .map((item) => ({
                        ...item,
                        count: item.count ?? 1,
                    }))
                    .sort((a, b) => getNumericPrice(a.title) - getNumericPrice(b.title));

                if (isMounted) {
                    setProducts(tikTokItems);
                }
            } catch (err) {
                console.error("TikTok məhsulları yüklənmədi:", err);

                if (isMounted) {
                    setError(
                        "Məhsullar yüklənərkən xəta baş verdi. Zəhmət olmasa yenidən cəhd edin."
                    );
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        getProducts();

        return () => {
            isMounted = false;
        };
    }, []);

    // WhatsApp sifarişi
    const handleOrder = (product) => {
        const title = product?.title || "TikTok Jeton";
        const price = product?.price ?? "";

        const message = `Salam, ${title} sifariş etmək istəyirəm.${price !== "" ? ` Qiymət: ${price}` : ""
            }`;

        const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
            message
        )}`;

        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <main
            className="
            min-h-screen w-full
            overflow-x-hidden
            bg-gray-50 text-gray-900
            transition-colors duration-300
            dark:bg-[#040209] dark:text-white
        "
        >
            {/* =========================================================
            ARXA FON EFFEKTİ
        ========================================================== */}
            <div className="pointer-events-none fixed inset-0 -z-0 overflow-hidden">
                <div
                    className="
                    absolute -left-32 -top-32
                    h-72 w-72 rounded-full
                    bg-pink-400/10 blur-3xl
                    dark:bg-[#ff0050]/10
                "
                />

                <div
                    className="
                    absolute -right-32 top-1/3
                    h-80 w-80 rounded-full
                    bg-cyan-400/10 blur-3xl
                    dark:bg-[#00f2ea]/10
                "
                />

                <div
                    className="
                    absolute bottom-0 left-1/3
                    h-72 w-72 rounded-full
                    bg-purple-400/10 blur-3xl
                    dark:bg-purple-700/10
                "
                />
            </div>

            {/* =========================================================
            BANER
        ========================================================== */}
            <section
                className="
                mx-auto
                w-full
                max-w-7xl
                overflow-hidden
                rounded-xl
                border
                border-gray-200
                bg-white
                shadow-[0_10px_35px_rgba(0,0,0,0.08)]
                sm:rounded-3xl
                dark:border-[#231842]
                dark:bg-[#0D081D]
                dark:shadow-[0_0_35px_rgba(139,92,246,0.3)]
            "
            >
                <a
                    href={`https://wa.me/${WHATSAPP_NUMBER}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group block w-full"
                >
                    <img
                        src={TikTokH}
                        alt="TikTok Jeton"
                        className="
                        block
                        h-auto
                        max-h-[210px]
                        w-full
                        object-cover
                        transition-transform
                        duration-500
                        group-hover:scale-[1.01]
                        sm:max-h-[280px]
                        lg:max-h-[300px]
                    "
                    />
                </a>
            </section>

            {/* =========================================================
            MƏHSULLAR
        ========================================================== */}
            <section
                className="
                relative z-10
                w-full
                px-1.5 py-4
                sm:px-5 sm:py-7
                md:px-8
                lg:px-10
            "
            >
                <div className="mx-auto w-full max-w-6xl">

                    {/* =====================================================
                    BAŞLIQ
                ====================================================== */}
                    <div className="mb-3 sm:mb-6">
                        <div className="flex items-center gap-2.5 sm:gap-3">

                            <div
                                className="
                                flex h-9 w-9 shrink-0
                                items-center justify-center
                                rounded-lg
                                bg-gradient-to-br
                                from-[#ff0050]
                                to-[#00f2ea]
                                text-base
                                shadow-lg
                                shadow-pink-500/20
                                sm:h-12 sm:w-12
                                sm:rounded-2xl
                                sm:text-lg
                            "
                            >
                                🎵
                            </div>

                            <div className="min-w-0">
                                <h1
                                    className="
                                    text-lg font-black tracking-tight
                                    text-gray-900
                                    sm:text-3xl
                                    dark:text-white
                                "
                                >
                                    TikTok Jeton
                                </h1>

                                <p
                                    className="
                                    mt-0.5 text-[10px]
                                    text-gray-500
                                    sm:text-sm
                                    dark:text-gray-400
                                "
                                >
                                    TikTok jeton paketlərini seçin və sifariş edin.
                                </p>
                            </div>

                        </div>
                    </div>

                    {/* =====================================================
                    LOADING
                ====================================================== */}
                    {loading && (
                        <div
                            className="
                            flex min-h-[180px]
                            items-center justify-center
                            rounded-xl
                            border border-gray-200
                            bg-white
                            shadow-sm
                            dark:border-white/10
                            dark:bg-[#100a1b]
                            dark:shadow-2xl
                        "
                        >
                            <div className="flex flex-col items-center gap-3">
                                <div
                                    className="
                                    h-9 w-9
                                    animate-spin
                                    rounded-full
                                    border-4
                                    border-gray-200
                                    border-t-[#ff0050]
                                    dark:border-white/10
                                    dark:border-t-[#ff0050]
                                "
                                />

                                <p
                                    className="
                                    text-xs
                                    text-gray-500
                                    dark:text-gray-400
                                "
                                >
                                    Məhsullar yüklənir...
                                </p>
                            </div>
                        </div>
                    )}

                    {/* =====================================================
                    ERROR
                ====================================================== */}
                    {!loading && error && (
                        <div
                            className="
                            rounded-xl
                            border border-red-200
                            bg-red-50
                            p-5 text-center
                            shadow-sm
                            dark:border-red-500/20
                            dark:bg-red-500/10
                        "
                        >
                            <div className="mb-3 text-3xl">⚠️</div>

                            <p
                                className="
                                text-sm
                                text-red-600
                                dark:text-red-400
                            "
                            >
                                {error}
                            </p>

                            <button
                                type="button"
                                onClick={() => window.location.reload()}
                                className="
                                mt-4
                                rounded-xl
                                bg-red-600
                                px-5 py-2.5
                                text-sm font-bold
                                text-white
                                shadow-lg shadow-red-600/20
                                transition
                                hover:bg-red-700
                                active:scale-95
                            "
                            >
                                Yenidən yoxla
                            </button>
                        </div>
                    )}

                    {/* =====================================================
                    EMPTY
                ====================================================== */}
                    {!loading && !error && products.length === 0 && (
                        <div
                            className="
                            rounded-xl
                            border border-gray-200
                            bg-white
                            p-7 text-center
                            shadow-sm
                            dark:border-white/10
                            dark:bg-[#100a1b]
                        "
                        >
                            <div className="mb-3 text-4xl">🎵</div>

                            <p
                                className="
                                text-sm
                                text-gray-500
                                dark:text-gray-400
                            "
                            >
                                Hazırda TikTok məhsulu yoxdur.
                            </p>
                        </div>
                    )}

                    {/* =====================================================
                    MƏHSUL CƏDVƏLİ
                ====================================================== */}
                    {!loading && !error && products.length > 0 && (
                        <div
                            className="
                            relative overflow-hidden
                            rounded-xl
                            border border-gray-200
                            bg-white
                            shadow-xl
                            shadow-gray-200/50
                            dark:border-[#241536]
                            dark:bg-[#0d0816]
                            dark:shadow-black/30
                        "
                        >
                            {/* Üst dekorativ xətt */}
                            <div
                                className="
                                absolute left-0 right-0 top-0 h-[2px]
                                bg-gradient-to-r
                                from-[#ff0050]
                                via-purple-500
                                to-[#00f2ea]
                            "
                            />

                            {/* Cədvəl */}
                            <div className="w-full overflow-x-auto">
                                <table
                                    className="
                                    w-full
                                    min-w-0
                                    border-collapse
                                "
                                >
                                    <thead>
                                        <tr
                                            className="
                                            border-b
                                            border-gray-200
                                            bg-gray-50
                                            dark:border-white/[0.07]
                                            dark:bg-white/[0.035]
                                        "
                                        >
                                            <th
                                                className="
                                                w-full
                                                px-1.5 py-2
                                                text-left
                                                text-[8px]
                                                font-black
                                                uppercase
                                                tracking-wide
                                                text-gray-500
                                                sm:px-4 sm:py-3
                                                sm:text-[11px]
                                                dark:text-gray-400
                                            "
                                            >
                                                Məhsul adı
                                            </th>

                                            <th
                                                className="
                                                whitespace-nowrap
                                                px-1.5 py-2
                                                text-left
                                                text-[8px]
                                                font-black
                                                uppercase
                                                tracking-wide
                                                text-gray-500
                                                sm:px-4 sm:py-3
                                                sm:text-[11px]
                                                dark:text-gray-400
                                            "
                                            >
                                                Qiymət
                                            </th>

                                            <th
                                                className="
                                                whitespace-nowrap
                                                px-1.5 py-2
                                                text-center
                                                text-[8px]
                                                font-black
                                                uppercase
                                                tracking-wide
                                                text-gray-500
                                                sm:px-4 sm:py-3
                                                sm:text-[11px]
                                                dark:text-gray-400
                                            "
                                            >
                                                Sifariş
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {products.map((product, index) => (
                                            <tr
                                                key={String(
                                                    product._id || index
                                                )}
                                                className="
                                                group
                                                border-b
                                                border-gray-100
                                                transition-all
                                                duration-200
                                                last:border-b-0
                                                hover:bg-gray-50
                                                dark:border-white/[0.05]
                                                dark:hover:bg-white/[0.025]
                                            "
                                            >
                                                {/* MƏHSUL */}
                                                <td
                                                    className="
                                                    min-w-0
                                                    px-1.5 py-2
                                                    sm:px-4 sm:py-3
                                                "
                                                >
                                                    <div
                                                        className="
                                                        flex
                                                        min-w-0
                                                        items-center
                                                        gap-1.5
                                                        sm:gap-2
                                                    "
                                                    >
                                                        <div
                                                            className="
                                                            flex h-6 w-6
                                                            shrink-0
                                                            items-center
                                                            justify-center
                                                            rounded-md
                                                            bg-gradient-to-br
                                                            from-[#ff0050]/10
                                                            to-[#00f2ea]/10
                                                            text-[9px]
                                                            font-black
                                                            text-gray-500
                                                            ring-1
                                                            ring-gray-200
                                                            sm:h-8 sm:w-8
                                                            dark:text-gray-400
                                                            dark:ring-white/10
                                                        "
                                                        >
                                                            {index + 1}
                                                        </div>

                                                        <div className="min-w-0">
                                                            <div
                                                                className="
                                                                max-w-[105px]
                                                                truncate
                                                                text-[10px]
                                                                font-bold
                                                                text-gray-800
                                                                sm:max-w-[300px]
                                                                sm:text-sm
                                                                dark:text-gray-100
                                                            "
                                                                title={
                                                                    product.title
                                                                }
                                                            >
                                                                {product.title}
                                                            </div>

                                                            <div
                                                                className="
                                                                mt-0.5
                                                                text-[7px]
                                                                font-medium
                                                                text-gray-400
                                                                sm:text-[10px]
                                                                dark:text-gray-500
                                                            "
                                                            >
                                                                TikTok Jeton
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* QİYMƏT */}
                                                <td
                                                    className="
                                                    whitespace-nowrap
                                                    px-1.5 py-2
                                                    sm:px-4 sm:py-3
                                                "
                                                >
                                                    <div
                                                        className="
                                                        inline-flex
                                                        items-center
                                                        rounded-md
                                                        bg-gradient-to-r
                                                        from-pink-500/10
                                                        to-purple-500/10
                                                        px-1.5 py-0.5
                                                        sm:px-2.5 sm:py-1.5
                                                    "
                                                    >
                                                        <span
                                                            className="
                                                            text-[10px]
                                                            font-black
                                                            text-[#e60046]
                                                            sm:text-sm
                                                            dark:text-[#ff3d76]
                                                        "
                                                        >
                                                            {product.price}
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* SİFARİŞ */}
                                                <td
                                                    className="
                                                    whitespace-nowrap
                                                    px-1.5 py-2
                                                    text-center
                                                    sm:px-4 sm:py-3
                                                "
                                                >
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            handleOrder(product)
                                                        }
                                                        className="
                                                        inline-flex
                                                        items-center
                                                        justify-center
                                                        gap-1
                                                        rounded-md
                                                        bg-gradient-to-r
                                                        from-[#16a34a]
                                                        to-[#22c55e]
                                                        px-2 py-1.5
                                                        text-[8px]
                                                        font-black
                                                        uppercase
                                                        tracking-wide
                                                        text-white
                                                        shadow-md
                                                        shadow-green-600/20
                                                        transition-all
                                                        duration-200
                                                        hover:-translate-y-0.5
                                                        hover:from-[#15803d]
                                                        hover:to-[#16a34a]
                                                        hover:shadow-lg
                                                        active:scale-95
                                                        sm:gap-2
                                                        sm:rounded-xl
                                                        sm:px-4 sm:py-2
                                                        sm:text-xs
                                                    "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="
                                                            h-3 w-3
                                                            sm:h-4 sm:w-4
                                                        "
                                                        >
                                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57.01-.198 0-.52.075-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                                                            <path d="M20.52 3.449A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.16 11.891c0 2.096.547 4.142 1.588 5.946L.057 24l6.304-1.654a11.89 11.89 0 005.684 1.447h.005c6.554 0 11.89-5.335 11.89-11.892a11.87 11.87 0 00-3.42-8.452zM12.05 21.785h-.004a9.88 9.88 0 01-5.031-1.378l-.361-.214-3.742.982 1-3.648-.235-.374a9.87 9.87 0 01-1.516-5.262c0-5.45 4.437-9.886 9.894-9.886a9.83 9.83 0 017.004 2.904 9.84 9.84 0 012.898 7.009c-.002 5.45-4.438 9.887-9.907 9.887z" />
                                                        </svg>

                                                        <span className="hidden sm:inline">
                                                            Sifariş et
                                                        </span>

                                                        <span className="sm:hidden">
                                                            Sifariş
                                                        </span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Alt dekorativ hissə */}
                            <div
                                className="
                                h-1
                                bg-gradient-to-r
                                from-transparent
                                via-[#ff0050]/20
                                to-transparent
                            "
                            />
                        </div>
                    )}
                </div>
            </section>
        </main>
    );

};

export default TikTok;
